<template>
  <div class="container-fluid">
    <page-header :page="page">
      <template #custom_actions>
        <menu-search v-if="menuAdvanceModeEnabled" v-model="searchQuery" />
      </template>
    </page-header>

    <menu-options
      :menu-title="menuTitle"
      :search="searchQuery"
      :can-navigate="validateStudent"
      :advance-mode="menuAdvanceModeEnabled"
    />
  </div>
</template>

<script>
import PageHeader from '@/components/common/page/PageHeader';
import { MenuOptions, MenuSearch } from '@/components/common/menu';
import menuNavigation from '@/mixin/menuNavigation.mixin';
import navMenuTitles from '@/utils/constants/navMenuTitles';

export default {
  name: 'OperationsMenu',
  mixins: [menuNavigation],
  components: {
    PageHeader,
    MenuOptions,
    MenuSearch,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-shield-alt',
        title: 'Operaciones',
        routes: ['Inicio', 'Operaciones'],
      },
      menuTitle: navMenuTitles.Operations,
      searchQuery: '',
    };
  },
  //Sin banderas de navegación: usa los valores por defecto del mixin
};
</script>
